export var TipoEnsaio;
(function (TipoEnsaio) {
    TipoEnsaio["NUMERO"] = "NUMERO";
    TipoEnsaio["TEXTO"] = "TEXTO";
    TipoEnsaio["DATA"] = "DATA";
    TipoEnsaio["LISTA"] = "LISTA";
})(TipoEnsaio || (TipoEnsaio = {}));
